import React from "react";

export default function AppHeader() {
    return <header className="App-header">
        <h1>Random Quote Machine</h1>
    </header>;
}
